import { usePeriod } from '../payload/PeriodContext'
import { Card } from './components'
import { agoDays, day, plural, s } from './format'

// Source names are translated here rather than shown: no engineering vocabulary
// reaches the screen.
const SOURCE_LABEL: Record<string, string> = {
  firestore_production: 'Accounts and saved answers',
  posthog: 'Website and app activity',
}

/** How far each source is loaded, and when the report was built. */
const Freshness = ({ generatedAt }: { generatedAt: string }) => {
  const { panel } = usePeriod()
  const rows = panel('meta')

  return (
    <Card>
      <div className="flex flex-wrap gap-6">
        {rows.map((row, i) => {
          const asOf = s(row.as_of)
          const ago = asOf ? agoDays(asOf) : null
          return (
            <p key={i} className="text-sm">
              {SOURCE_LABEL[s(row.source)] ?? s(row.source)} up to{' '}
              <strong>{day(asOf)}</strong>
              {ago !== null &&
                (ago === 0 ? ' (today)' : ` (${plural(ago, 'day')} ago)`)}
            </p>
          )
        })}
        <p className="text-muted text-sm">Report built {day(generatedAt)}</p>
      </div>
    </Card>
  )
}

export default Freshness
